export const CANCEL_ORDER = 'CANCEL_ORDER';
export const CANCELING_ORDER = 'CANCELING_ORDER';
export const CLEAR_ORDERS = 'CLEAR_ORDERS';
export const CLEAR_ORDERS_DONE = 'CLEAR_ORDERS_DONE';
export const GET_ORDERS = 'GET_ORDERS';
export const GET_ORDERS_DONE = 'GET_ORDERS_DONE';
export const GETTING_ORDERS = 'GETTING_ORDERS';
export const SEND_ORDER = 'SEND_ORDER';
export const SENDING_ORDER = 'SENDING_ORDER';
